import * as React from "react";

function SvgCheck(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 53 37"
      {...props}
    >
      <path
        d="M48.108 1.444L18.599 30.952a1.64 1.64 0 01-2.298 0L5.36 20.01a2.736 2.736 0 00-3.867 0 2.81 2.81 0 000 3.903l10.943 10.942a7.078 7.078 0 0010.031 0L51.975 5.347a2.736 2.736 0 10-3.866-3.867v-.036z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCheck;
